/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-no-result-message',
    templateUrl: './no-result-message.component.html',
    styleUrls: ['./no-result-message.component.scss'],
    standalone: false
})
export class NoResultMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
